import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-3 mt-5 pb-24" }
const _hoisted_2 = { class: "pl-3 font-bold my-3" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = { class: "flex items-center gap-3 mb-3" }
const _hoisted_5 = { class: "text-left" }
const _hoisted_6 = { class: "font-bold" }
const _hoisted_7 = { class: "text-sm" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["id"]
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = { class: "flex items-center gap-3 mb-3" }
const _hoisted_13 = { class: "text-left" }
const _hoisted_14 = { class: "font-bold" }
const _hoisted_15 = { class: "text-sm" }
const _hoisted_16 = ["innerHTML"]

import { ref } from "vue"
  import { IonSlides, IonSlide } from "@ionic/vue"

  import CardTemplate from "@/components/template/CardTemplate.vue"
  import BottomModal from "@/components/template/BottomModal.vue"
  import AvatarTemplate from "@/components/template/avatarTemplate.vue"

  interface Details {
    image: string
    name: string
    position: string
    testimonial: string
  }

  interface Props {
    reviews: Details[]
    companyName: string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'EmployeeReviews',
  props: {
    reviews: {},
    companyName: {}
  },
  setup(__props: any) {

const props = __props;

  const activeEmployee = ref("")

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.companyName) + _toDisplayString(_ctx.companyName.endsWith("s") ? "'" : "'s") + " Employee Reviews", 1),
    _createVNode(_unref(IonSlides), { class: "swiper-slide-img" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reviews, (review, index) => {
          return (_openBlock(), _createBlock(_unref(IonSlide), {
            key: `${review}_id`,
            class: "swiper-slide"
          }, {
            default: _withCtx(() => [
              _createVNode(CardTemplate, { class: "w-[19rem] flex flex-col" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(AvatarTemplate, {
                        image: review.image,
                        class: "overflow-hidden"
                      }, null, 8, ["image"]),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("p", _hoisted_6, _toDisplayString(review.name), 1),
                        _createElementVNode("p", _hoisted_7, _toDisplayString(review.position), 1)
                      ])
                    ])
                  ]),
                  (review.testimonial.length > 250)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: "text-left text-light-gray-200",
                        innerHTML: `${review.testimonial.slice(0, 250)}...`
                      }, null, 8, _hoisted_8))
                    : (_openBlock(), _createElementBlock("p", {
                        key: 1,
                        class: "text-left text-light-gray-200",
                        innerHTML: review.testimonial
                      }, null, 8, _hoisted_9)),
                  (review.testimonial.length > 250)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        id: `${index}_modal`,
                        class: "underline text-light-gray-200 text-left font-semibold"
                      }, "See more", 8, _hoisted_10))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024),
              _createVNode(BottomModal, {
                type: `${index}_modal`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(AvatarTemplate, {
                        image: review.image
                      }, null, 8, ["image"]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("p", _hoisted_14, _toDisplayString(review.name), 1),
                        _createElementVNode("p", _hoisted_15, _toDisplayString(review.position), 1)
                      ])
                    ]),
                    _createElementVNode("p", {
                      class: "text-left text-light-gray-200",
                      innerHTML: review.testimonial
                    }, null, 8, _hoisted_16)
                  ])
                ]),
                _: 2
              }, 1032, ["type"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})